import LocationItem from './LocationItem';
import Pagination from './Pagination';

const List = ({ currentItems, currentPage, totalPages, onPageChange }) => {
  if (currentItems.length === 0) {
    return (
      <div className="uberall-locations__list" id="uberall-locations__list">
        <p className="uberall-locations__no-results">Keine Standorte gefunden</p>
      </div>
    );
  }

  return (
    <div className="uberall-locations__list" id="uberall-locations__list">
      <ul className="uberall-locations__items">
        {currentItems.map((location, index) => (
          <LocationItem key={index} location={location} />
        ))}
      </ul>
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
    </div>
  );
};

export default List;
